import {Box, Typography} from '@mui/material';
import {t} from 'i18next';

export const EditProjectTooltip = () => {
  return (
    <Box>
      <Box>
        <>
          <Typography
            className="typo-text headline6_size"
            data-testid={`edit-project-tooltip-intro`}>
            {t('projectManagement.editProject.tooltip.intro')}
          </Typography>
          <ul data-testid={`edit-project-tooltip-step1-step2-step3-step4-step5-step6`}>
            <li data-testid={`edit-project-tooltip-step1`}>
              <span data-testid={`edit-project-tooltip-step1-text`}>{t('projectManagement.editProject.tooltip.step1')}</span>
            </li>
            <li data-testid={`edit-project-tooltip-step2`}> {t('projectManagement.editProject.tooltip.step2')}</li>
            <li data-testid={`edit-project-tooltip-step3`}> {t('projectManagement.editProject.tooltip.step3')}</li>
            <li data-testid={`edit-project-tooltip-step4`}> {t('projectManagement.editProject.tooltip.step4')}</li>
            <li data-testid={`edit-project-tooltip-step5`}> {t('projectManagement.editProject.tooltip.step5')}</li>
            <li data-testid={`edit-project-tooltip-step6`}> {t('projectManagement.editProject.tooltip.step6')}</li>
          </ul>
        </>
      </Box>
    </Box>
  );
};
